const PILLS = {
  ALL: 'Все',
  NEWS: 'Новости',
  PROMOTIONS: 'Акции',
  CONNECTION: 'Связь',
  INTERNET: 'Интернет',
};

export { PILLS };
